import { Link } from "react-router-dom";
// import banner2 from "../../../assets/images/media/banner2.png";
// import banner2_1 from "../../../assets/images/media/banner2.1.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

function BannerTwo() {
 return (
  <div className="hero-banner-promo-two">
   <div className="body">
    <div className="section-text">
     <h2>Listo para tener tu Tienda Virtual</h2>
     <div className="content-button">
      <Link to={"/nueva-tienda"} className="btn-one">
       Crea tu tienda HOY
      </Link>
      <a href={"https://wa.me/51991115871"} target="_blank" className="btn-two">
       Agenda una Demo
      </a>
     </div>
     <div>
      <p>
       *¡Despreocúpate! PowerBizz te da el hosting cómo parte del servicio.{" "}
      </p>
     </div>
    </div>
    <div className="section-banner">
     <div className="purple-square"></div>
     <LazyLoadImage
      className="banner"
      src={"https://a-s3-backoffice.s3.amazonaws.com/web/banner2_oaqito.png"}
     />
    </div>
   </div>
  </div>
 );
}

export default BannerTwo;
